import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{attrs:{"icon":"","color":"deep-orange"},on:{"click":_vm.openActionSwal}},[_c(VIcon,{staticStyle:{"font-size":"20px !important"}},[_vm._v("mdi-archive-cog")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }